import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FaChevronDown } from "react-icons/fa";

function FAQs({ item, index }) {
  const { t } = useTranslation();

  const [show, setShow] = useState(true);
  const [faqheight, setFaqheight] = useState<number | undefined>(undefined);

  useEffect(() => {
    const he = document.getElementById(`faq${index}`);
    setFaqheight(he.clientHeight);
  }, [faqheight, index]);

  return (
    <>
      <div className="border-b border-gray-300 py-4 w-full">
        <button
          onClick={() => setShow(!show)}
          className="flex justify-between gap-4 w-full"
        >
          <h2
            className={`min-[460px]:text-lg min-[460px]:leading-6 leading-5 font-medium text-left ${
              show ? "text-brand-color" : "text-gray-700"
            }`}
          >
            {t(item.question)}
          </h2>
          <div>
            <FaChevronDown
              className={`mt-1.5 transition-all ${
                show ? "text-brand-color rotate-180" : "text-gray-700"
              }`}
            />
          </div>
        </button>
        <div
          style={{
            height: show ? faqheight : 0,
          }}
          className={`w-full transition-all duration-200 ease-in-out overflow-hidden`}
        >
          <p
            className={`text-gray-500 pt-1 min-[460px]:leading-6 leading-5`}
            id={`faq${index}`}
          >
            {t(item.answer)}
          </p>
        </div>
      </div>
    </>
  );
}

export default FAQs;
